
import { SubFsmBuilder } from "little-fsm";
import { PaymenCompletedFsmContext } from "./PaymentCompleteFsmContext";


export type PaymentCompletedFsmScheme = {
    context: PaymenCompletedFsmContext,
    substates: [
        'initial',
        'back_navigation_confirming'

    ],
    events: {
        'closed': {},
        'back': {},
        'force_back_to_home': {},
        'back_confirmed': {},
        'back_cancelled': {},
    }
}

// just simple identity function
const $I = (x) => x;

export function paymentCompleteSubFsmBuilder(): SubFsmBuilder<PaymentCompletedFsmScheme> {
    let subBuilder = new SubFsmBuilder<PaymentCompletedFsmScheme>();

    subBuilder.entrySubstate("initial")

    subBuilder.substate("initial")
        .transition("back", "back_navigation_confirming", (c, e) => c)
        .completion("closed", (c, e) => c)
        .termination('force_back_to_home', $I) 


    subBuilder.substate("back_navigation_confirming")
        .transition('back_cancelled', 'initial', $I)
        .termination('back_confirmed', $I) 
    return subBuilder;
}


